import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useApp } from "@/context/AppContext";

// EU/EEA + UK — regions where a GDPR cookie consent banner is required.
const GDPR_REGIONS = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT",
  "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "IS", "LI", "NO", "GB",
]);
const KEY = "anxya_cookie_consent";

export default function CookieConsent() {
  const { country } = useApp();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    if (country && GDPR_REGIONS.has(String(country).toUpperCase())) setShow(true);
  }, [country]);

  const decide = (choice) => { localStorage.setItem(KEY, choice); setShow(false); };
  if (!show) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[70] rud-card rounded-2xl p-4 shadow-2xl" data-testid="cookie-consent">
      <div className="flex items-start gap-2">
        <Cookie size={18} className="text-brand shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="text-sec">We use only essential cookies to keep you signed in and to remember your preferences. With your consent, we may use a few to improve your experience. See our <Link to="/privacy" className="text-brand">Privacy Policy</Link>.</p>
          <div className="flex gap-2 mt-3">
            <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="btn-primary rounded-full h-9 px-4 text-xs">Accept</button>
            <button data-testid="cookie-reject" onClick={() => decide("rejected")} className="btn-ghost rounded-full h-9 px-4 text-xs">Reject non-essential</button>
          </div>
        </div>
      </div>
    </div>
  );
}
